// extracted by css-extract-rspack-plugin
export default {"titleCardContainer":"TitleCard_titleCardContainer__Kq9d8","title":"TitleCard_title__r0QM-","description":"TitleCard_description__cYta9"};